export default {
	$html: $(document.documentElement),
	$itemKeyWords: $('ul.b-aside-filter__aside-list--key-words li'),
	$materialsFiltersList: $(document.getElementsByClassName("b-materials__list-filter")),
	$materialsAddition: $(document.getElementsByClassName("b-materials__addition")),
	$materialsReset: $(document.getElementsByClassName("b-materials__item-filter--reset")),
	$asideFilter: $(document.getElementsByClassName("b-aside-filter")),
	$asidePeriods: $(document.getElementsByClassName("b-aside-filter__periods")),
	$asidePeriod: $(document.getElementsByClassName("b-aside-filter__period")),
	$asidePeriodPrevInput: $(document.getElementsByClassName("b-aside-filter__period-prev")),
	$asidePeriodNextInput: $(document.getElementsByClassName("b-aside-filter__period-next")),
	$asideAll: $(document.getElementsByClassName("b-aside-filter__all")),
	$asideItem: $(document.getElementsByClassName("b-aside-filter__aside-item")),
	$asideBtnClose: $(document.getElementsByClassName("b-aside-filter__btn-close")),
	$asideBtnApply: $(document.getElementsByClassName("b-aside-filter__btn-apply")),
	$asideKeyWords: $(document.getElementsByClassName("b-aside-filter__aside-list--key-words")),
	$periods: $(document.getElementsByClassName("b-periods")),
	$pagination: $(document.getElementsByClassName("b-pagination")),
	$crossBtnSearch: $(document.getElementsByClassName("b-btn-cancel--search")),
	$crossBtnContent: $(document.getElementsByClassName("b-btn-cancel--content")),
	$allExponatsList: $(document.getElementsByClassName("b-all-exponats__list")),
	$overlay: $(document.getElementsByClassName("b-overlay")),
	$modalExponat: $(document.getElementsByClassName("b-modal-exponat")),
	$btnClose: $(document.getElementsByClassName("b-btn-close")),
	$modalExponatClose: $(document.getElementsByClassName("b-modal-exponat__close")),
	$asideFilterComponent: $(document.getElementsByClassName("b-aside-filter__component")),
	$notice: $(document.getElementsByClassName("b-notice")),
	$noticeClose: $(document.getElementsByClassName("b-notice__close")),

	$btnFilter: $(document.getElementById("btn-filter")),
	$btnFilterFilled: $(document.getElementById("btn-filter-filled")),

	titleAccordion: document.getElementsByClassName("b-aside-filter__title--disclosed"),
	titleKeyWords: document.getElementsByClassName("title-key-words"),

	textFilterSpan: document.getElementById("text-filter-span"),

	$Autocomplete: $('.js-autocomplete'),
	$AutocompleteShow: $('.js-autocomplete-show'),
}


// WEBPACK FOOTER //
// ./src/js/vars.js